import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
interface IBreadcumb {
  route: string;
  label: string;
}
export interface IRouterState {
  breadcumbs: Array<IBreadcumb>;
  updateRoute: boolean;
  addRoute: boolean;
}

const initialState: IRouterState = {
  breadcumbs: [],
  updateRoute: false,
  addRoute: false,
};

export const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    updateRoute: (state: IRouterState, action: PayloadAction<Array<IBreadcumb>>) => {
      state.breadcumbs = action.payload;
    },
    addRoute: (state: IRouterState, action: PayloadAction<Array<IBreadcumb>>) => {
      state.breadcumbs.concat(...action.payload);
    },
  },
});

export const { updateRoute, addRoute } = routerSlice.actions;

export default routerSlice.reducer;
